import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useInteraction } from '../InteractionContext.js';
import { getEmphasis, toText } from '../layout.js';
import { AvatarFallback, AvatarImage, Avatar as ShadcnAvatar } from '../ui/avatar.js';
export function Avatar({ element }) {
    const { content, props } = element;
    const { handleAction } = useInteraction();
    const emphasis = getEmphasis(props);
    const isActive = props.active === true;
    const src = props.src;
    const textContent = toText(content);
    const toValue = props.to;
    // Generate initials from content
    const initials = textContent
        ? textContent
            .split(' ')
            .map((s) => s[0])
            .join('')
            .toUpperCase()
            .slice(0, 2)
        : '?';
    // Size config: avatarSize in px, dot size, and pre-calculated offset
    // Offset positions the dot so its center sits on the circle edge at 45° (bottom-right)
    const sizeConfig = {
        high: { size: 56, className: 'text-xl', dotSize: 12, dotOffset: 2 },
        medium: { size: 40, className: 'text-base', dotSize: 10, dotOffset: 1 },
        low: { size: 32, className: 'text-sm', dotSize: 8, dotOffset: 0 },
    };
    const config = sizeConfig[emphasis];
    // Handle click for :to prop
    const handleClick = () => {
        if (!toValue)
            return;
        if (typeof toValue === 'object' && 'type' in toValue) {
            switch (toValue.type) {
                case 'screen':
                    handleAction(toValue.id);
                    break;
                case 'overlay':
                    handleAction(`#${toValue.id}`);
                    break;
                case 'action':
                    handleAction(`:${toValue.action}`);
                    break;
                case 'url':
                    window.open(toValue.url, '_blank');
                    break;
            }
        }
        else if (typeof toValue === 'string') {
            handleAction(toValue);
        }
    };
    const avatarElement = (_jsxs("div", { className: "relative inline-block", style: { width: config.size, height: config.size }, children: [_jsxs(ShadcnAvatar, { className: config.className, style: { width: config.size, height: config.size }, children: [src && _jsx(AvatarImage, { src: src, alt: textContent || 'Avatar' }), _jsx(AvatarFallback, { className: "bg-primary text-primary-foreground font-semibold", children: initials })] }), isActive && (_jsx("span", { className: "absolute block rounded-full bg-green-500 ring-2 ring-background", style: {
                    width: config.dotSize,
                    height: config.dotSize,
                    bottom: config.dotOffset,
                    right: config.dotOffset,
                }, title: "Online" }))] }));
    // Wrap in clickable button if :to is provided
    if (toValue) {
        return (_jsx("button", { type: "button", onClick: handleClick, className: "rounded-full hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", children: avatarElement }));
    }
    return avatarElement;
}
//# sourceMappingURL=Avatar.js.map